<template>
    <li class="bg-white rounded-md p-1.5 px-2 text-white flex gap-1 items-center cursor-pointer">
       <slot />
    </li>
</template>
